import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    dashboardRes: null,
    pendingTATRes: null,
    pendingTATLoading: false,
    tatRes: null,
    workloadRes: null,
    rejectionRateRes: null,
    testVolumeRes: null,
    qcPerformanceRes: null,
    overviewRes: null,
    overviewLoading: false,
};

const slice = createSlice({
    name: 'labAnalytics',
    initialState,
    reducers: {
        getAnalyticsDashboardRequest: (state) => { state.loading = true; },
        getAnalyticsDashboardSuccess: (state, action) => { state.loading = false; state.dashboardRes = action.payload; },
        getAnalyticsDashboardFailure: (state, action) => { state.loading = false; state.dashboardRes = action.payload; },
        resetAnalyticsDashboard: (state) => { state.dashboardRes = null; },

        // Dedicated loading flag — the dashboard polls this every minute and
        // must not flip the global `loading` used by the stat cards.
        getPendingTATRequest: (state) => { state.pendingTATLoading = true; },
        getPendingTATSuccess: (state, action) => { state.pendingTATLoading = false; state.pendingTATRes = action.payload; },
        getPendingTATFailure: (state) => { state.pendingTATLoading = false; },
        resetPendingTAT: (state) => { state.pendingTATRes = null; },

        getTATRequest: (state) => { state.loading = true; },
        getTATSuccess: (state, action) => { state.loading = false; state.tatRes = action.payload; },
        getTATFailure: (state, action) => { state.loading = false; state.tatRes = action.payload; },
        resetTAT: (state) => { state.tatRes = null; },

        getWorkloadRequest: (state) => { state.loading = true; },
        getWorkloadSuccess: (state, action) => { state.loading = false; state.workloadRes = action.payload; },
        getWorkloadFailure: (state, action) => { state.loading = false; state.workloadRes = action.payload; },
        resetWorkload: (state) => { state.workloadRes = null; },

        getRejectionRateRequest: (state) => { state.loading = true; },
        getRejectionRateSuccess: (state, action) => { state.loading = false; state.rejectionRateRes = action.payload; },
        getRejectionRateFailure: (state, action) => { state.loading = false; state.rejectionRateRes = action.payload; },
        resetRejectionRate: (state) => { state.rejectionRateRes = null; },

        getTestVolumeRequest: (state) => { state.loading = true; },
        getTestVolumeSuccess: (state, action) => { state.loading = false; state.testVolumeRes = action.payload; },
        getTestVolumeFailure: (state, action) => { state.loading = false; state.testVolumeRes = action.payload; },
        resetTestVolume: (state) => { state.testVolumeRes = null; },

        getQCPerformanceRequest: (state) => { state.loading = true; },
        getQCPerformanceSuccess: (state, action) => { state.loading = false; state.qcPerformanceRes = action.payload; },
        getQCPerformanceFailure: (state, action) => { state.loading = false; state.qcPerformanceRes = action.payload; },
        resetQCPerformance: (state) => { state.qcPerformanceRes = null; },

        // Turnaround overview (features['lis.analyticsOverview']); its own loading flag.
        getOverviewRequest: (state) => { state.overviewLoading = true; },
        getOverviewSuccess: (state, action) => { state.overviewLoading = false; state.overviewRes = action.payload; },
        getOverviewFailure: (state, action) => { state.overviewLoading = false; state.overviewRes = action.payload; },
    }
});

export const {
    getAnalyticsDashboardRequest, getAnalyticsDashboardSuccess, getAnalyticsDashboardFailure, resetAnalyticsDashboard,
    getPendingTATRequest, getPendingTATSuccess, getPendingTATFailure, resetPendingTAT,
    getTATRequest, getTATSuccess, getTATFailure, resetTAT,
    getWorkloadRequest, getWorkloadSuccess, getWorkloadFailure, resetWorkload,
    getRejectionRateRequest, getRejectionRateSuccess, getRejectionRateFailure, resetRejectionRate,
    getTestVolumeRequest, getTestVolumeSuccess, getTestVolumeFailure, resetTestVolume,
    getQCPerformanceRequest, getQCPerformanceSuccess, getQCPerformanceFailure, resetQCPerformance,
    getOverviewRequest, getOverviewSuccess, getOverviewFailure,
} = slice.actions;

export default slice.reducer;
